<template>
    <v-card
            class="mx-auto"
            max-width="434"
            tile
    >
        <!--        src="https://cdn.vuetifyjs.com/images/cards/server-room.jpg"-->
        <v-img
                height="100%"
                :src="require('../assets/medic-bg.jpg')"
        >
            <v-row
                    align="end"
                    class="fill-height"
            >
                <v-col
                        align-self="start"
                        class="pa-0"
                        sm="12"
                        lg="6"
                >
                    <v-avatar
                            class="profile"
                            color="grey"
                            width="200"
                            height="260"
                            tile
                    >
                        <v-img :src="medic.profilePic"></v-img>
                    </v-avatar>
                </v-col>
                <v-col sm="12"
                       lg="6" align-self="start">
                    <p>
                        {{ medic.background }}
                    </p>
                </v-col>
                <v-col class="py-0">
                    <v-list-item
                            color="black"
                            dark
                    >
                        <v-list-item-content>
                            <v-list-item-title class="title">{{ medic.title + ' ' + medic.fullName }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Medical Doctor</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
            </v-row>
        </v-img>
    </v-card>
</template>

<script>
    export default {
        name: "MedicCard",
        props: ['medic']
    }
</script>

<style scoped>
    .v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle {
        color: black;
    }
</style>
